import React, { useState } from 'react';
import NavDropdown from 'react-bootstrap/NavDropdown';
// import { useTranslation } from 'react-i18next';  
import i18n from 'i18next';

const LangSwitch = (props: any) => {
    const lngs = [  
            { code: 'en', nativeName: 'EN' },  
            { code: 'bg', nativeName: 'BG' },  
    ];
    let [expand, setExpand] = useState(false);
    const langLabel = localStorage.getItem('lngPref') ? localStorage.getItem('lngPref') : 'bg';
    const [lngLabel, setLngLabel] = useState(langLabel);
    const swithLng = (code: string) => {
        setLngLabel(code);
        i18n.changeLanguage(code);
        toggleNav();
        localStorage.setItem('lngPref', code); 
    }
    
    const toggleNav = () => {
        setExpand(!expand);
        props.sendToggle(false);
    }

    return (
        <>
            <span className='switch-label'>{lngLabel}</span>
            <NavDropdown title="" id="basic-nav-dropdown" className='globe' onClick={() => props.sendToggle(true)}>
                {lngs.map((lng) => {  
                    return (  
                        <div key={lng.code} onClick={() => swithLng(lng.code)}  >
                            {lng.nativeName} 
                        </div> 
                    );  
                })} 

            </NavDropdown>
        </>
    )
}

export default LangSwitch;